import {
    Table,
    Container,
    Row
} from "reactstrap";
import { Button } from "reactstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { getOrganization, updateOrganization } from '../../utilities/orgPanelApiCalls'
import { useState } from "react";
import "bootstrap/js/src/collapse.js";
import { errorToast, successToast } from '../../constants/toast';
import OrganizationModal from '../../components/Modals/OrganizationCRUModal.js'

const OrgSearchRow = ({ data, type, toggleUpdateModal, activeRow, setActiveRow }) => {
    const target = ".multi-collapse-" + data.accountId;
    const control = "multiCollapse-" + data.accountId;
    const chevronId = "chevron-" + data.accountId;
    const [isExpanded, setIsExpanded] = useState(false);
    return (
        <>
            <tr>

                {type === "device" && <td>{data.serialNumber}</td>}
                <th>{data.name}</th>
                <td>{data.address}
                    {
                        data.address2 !== "" && data.address2 !== null ?
                            <ToggleIcon isExpanded={isExpanded} setIsExpanded={setIsExpanded} chevronId={chevronId} target={target} control={control} dataId={data.accountId} ></ToggleIcon>
                            : null
                    }
                </td>
                <td></td>
                <td>{data.accountId}</td>
                <td>
                    <Button size="sm" type="button" onClick={() => { toggleUpdateModal(data.accountId) }} color="info" outline>Edit</Button>
                </td>
            </tr>
            <OrgSearchChildRow data={data}></OrgSearchChildRow>
        </>
    )
};

const ToggleIcon = ({ isExpanded, setIsExpanded, chevronId, target, control, dataId }) => {
    return (<FontAwesomeIcon id={chevronId} className="address-chevron" icon={isExpanded ? faChevronDown : faChevronRight} data-toggle="collapse" data-target={target} aria-controls={control} onClick={() => setIsExpanded(!isExpanded)} />)
}

const OrgSearchHeader = ({ type }) => {

    return (
        <tr>
            {type === "device" && <th>Serial Number</th>}
            <th>Location Name</th>
            <th>Address</th>
            <th>Description</th>
            <th>Location Id</th>
            <th>Actions</th>
        </tr>
    )
};

const OrgSearchChildRow = ({ data }) => {
    const targetClass = "collapse address2-row multi-collapse-" + data.accountId;
    const targetId = "multiCollapse-" + data.accountId;
    return (
        <tr className={targetClass} id={targetId} >
            <td></td>
            <td>{data.address2}</td>
            <td></td>
            <td></td>
            <td></td>
        </tr>)

}

const OrgSearchEmptyHeader = () => {
    return (
        <tr>
            <th></th>
        </tr>
    )
};

const OrgSearchEmptyResultsRow = () => {
    return (
        <tr>
            <td><h4 className="text-center">No Results Found</h4></td>
        </tr>
    )
};

const OrgSearchTable = ({ data, type, makeToast, refresh }) => {
    const [updateModalShowing, setUpdateModalShowing] = useState(false);
    const [isModalLoading, setIsModalLoading] = useState(true);
    const [updateData, setUpdateData] = useState(null);

    const toggleUpdateModal = (accountID) => {
        setUpdateModalShowing(true);
        setIsModalLoading(true);
        async function process() {
            if (updateModalShowing) {
                //if closing modal -
                setUpdateModalShowing(false);
                setIsModalLoading(true);

            }
            else {
                // if opening modal - load data
                var updateData = await getOrganization(accountID);
                setUpdateData(updateData.data);
                setIsModalLoading(false);
            }
        } process();
    }

    const handleUpdate = (event) => {
        event.preventDefault();

        let model = {
            addressId: parseInt(event.target.id.value),
            name: event.target.name.value,
            accountId: parseInt(event.target.accountId.value),
            address1: event.target.address1.value,
            address2: event.target.address2.value,
            city: event.target.city.value,
            state: event.target.state.value,
            zip: event.target.zip.value,
            phone: event.target.phone.value,
            language: event.target.language.value,
            Languages: [event.target.language.value]
        }
        async function put() {
            setIsModalLoading(true);
            var response = await updateOrganization(model.accountId, model);

            if (response.status > 299) {
                makeToast(response.data, errorToast);
                setIsModalLoading(false);
            }
            else {
                makeToast('Location Updated', successToast);
                toggleUpdateModal();
                refresh();
            }
        } put();
    };

    return (
        <>
            <Container fluid>
                <Row className="table-responsive table-sm">
                    <Table className="table-sm table-striped">
                        <thead className="search-thead">
                            {(data === null || data.length === 0) && <OrgSearchEmptyHeader />}
                            {data !== null && data.length > 0 && <OrgSearchHeader type={type} />}
                        </thead>
                        <tbody className="search-tbody">
                            {(data === null || data.length === 0) && <OrgSearchEmptyResultsRow />}
                            {data.map((row) => {

                                return <OrgSearchRow key={`${row.accountId}`} data={row} type={type} toggleUpdateModal={toggleUpdateModal} />
                            })
                            }
                        </tbody>
                    </Table>
                </Row>
                {updateModalShowing && (
                    <OrganizationModal isOpen={updateModalShowing} toggle={toggleUpdateModal} submitHandler={handleUpdate} data={updateData} isLoading={isModalLoading} />
                )}
            </Container>
        </>)
};

export default OrgSearchTable;